import { FloatingLoader, NavigationBack, Typography } from "@/components";
import { AppBarRightIcon } from "@/components/ui";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Toolbar from "@mui/material/Toolbar";
import { ChatGroupTabs } from "../$channelName";
import EmptyChat from "../../../-components/Empty";

const PendingComponent = () => {
	return (
		<>
			<AppBar
				position="relative"
				color="transparent"
				className="!bg-gradient-chat [&_*_]:text-white"
			>
				<Toolbar className="container !gap-4">
					<NavigationBack />
					<div className="flex flex-col justify-center items-start flex-1">
						<Typography fontSize={14} fontWeight={600}>
							Group Chat
						</Typography>
						<Typography fontSize={10} fontWeight={400}>
							-
						</Typography>
					</div>
					<div>
						<IconButton color="primary">
							<PersonAddIcon className="text-default " />
						</IconButton>
						<AppBarRightIcon hideSetting />
					</div>
				</Toolbar>
				<Toolbar
					className="[&_.MuiTabs-flexContainer]:md:justify-center [&_.MuiTabs-flexContainer]:justify-normal"
					classes={{
						root: "!p-0 !items-end",
					}}
				>
					<Tabs
						variant="scrollable"
						indicatorColor="primary"
						textColor="inherit"
						scrollButtons="auto"
						aria-label="scrollable auto tabs example chat"
						className="w-full [&_span.MuiTabs-indicator]:!bg-white"
					>
						{ChatGroupTabs.map((tab) => (
							<Tab
								key={tab.value}
								label={tab.label}
								sx={{ textTransform: "none" }}
							/>
						))}
					</Tabs>
				</Toolbar>
			</AppBar>
			<main className="relative flex-1 flex-col justify-center items-center">
				<FloatingLoader open />
				<EmptyChat />
			</main>
		</>
	);
};

export default PendingComponent;
